module.exports = __webpack_public_path__ + "img/zuanshiicon.72ead500.png";